import { URI } from '@/config/config'

export default async ({ rootState }) => {
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken
    }
  }

  const requestList = await fetch(`${URI}control-panel/roles/sectors`, opts)
  const jsonResult = await requestList.json()

  if (jsonResult.errors) {
    return Promise.reject(jsonResult.errors)
  }

  return jsonResult
}